<template>
    <div class="DispatchFilesToTeam">
        <button class="form-control btn btn-secondary" @click="OpenModal">EMAIL {{ FileType }}</button>

        <!--MODAL-->
        <b-modal ref="modal" size="lg" :title="'EMAIL ' + FileType" hide-footer>
            <b-container>
                <b-form @submit="DispatchEmails" ref="dispatchform">
                    <div>
                        <p class="bold">This tool will send emails to the recipients indicated, along with a file attachment.  Emails will only be sent when a file is present.  In addition, a service log entry will be added indicating the type of file sent, and a list of recipients.  The Service Log entry can be updated once created if needed.  Future updates to this tool will include the ability to set an email signature (currently not added automatically), and the ability to capture the file sent for display in the service log (currently, the file is only sent and not presevered in the database)</p>
                    </div>
                    <div v-for="checklist in ChecklistData" style="margin-top:30px;">
                        <b-row>
                            <b-col>
                                <h3>{{ checklist.ClientName }} <span class="red" v-if="checklist.OffWeekValue">(OFF WEEK)</span></h3>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>File</label>
                                    <b-form-file accept=".pdf, .docx, .doc"
                                                 :name="'File_' + checklist.ClientSubProgramMembershipID"
                                                 placeholder="Select File"
                                                 drop-placeholder="Drop word or pdf here..."></b-form-file>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <label>Subject:</label>
                                    <input type="text" class="form-control" :name="'Subject_' + checklist.ClientSubProgramMembershipID" />
                                </div>
                                <div class="form-group">
                                    <label>Message:</label>
                                    <textarea class="form-control" rows="4" :name="'Message_' + checklist.ClientSubProgramMembershipID"></textarea>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row style="border-bottom:solid;">
                            <b-col>
                                <p class="underline bold">Send File To: <span class="link-like" @click="SelectAllRecipients(checklist.ClientSubProgramMembershipID, DispatchRecipients[checklist.ClientSubProgramMembershipID])">(all)</span></p>
                                <p v-for="(recipient, index) in DispatchRecipients[checklist.ClientSubProgramMembershipID]" >
                                    <input :ref="'Recipient' + index +'_' + checklist.ClientSubProgramMembershipID" type="checkbox" :name="'Recipient' + index +'_' + checklist.ClientSubProgramMembershipID" :value="recipient.Email" /> {{recipient.Title}}: {{ recipient.Name }} ({{ recipient.Email }})
                                </p>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SEND EMAILS
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import components
    import { EventBus } from '../../../services/event-bus.js';


    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheckSquare);
    import { faSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faSquare);

    export default {
        created() {
        },
        data: function () {
            return {
                DispatchRecipients: []
            };
        },
        props: [
            "ChecklistData",
            "FileType"
        ],
        methods: {
            OpenModal() {
                this.DispatchRecipients = [];
                this.GetDispatchRecipients();
            },
            CancelModal() {
                this.$refs['modal'].hide();
            },
            GetDispatchRecipients() {
                let clientProgIds = [];
                this.ChecklistData.forEach(function (item) {
                    clientProgIds.push(item.ClientSubProgramMembershipID)
                });
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/ClientAppointments/GetDispatchRecipients", { ClientSubProgramMembershipIDs: clientProgIds }, this.GetDispatchRecipientsSuccess, () => { }, true);
            },
            GetDispatchRecipientsSuccess(response) {
                this.DispatchRecipients = response.data.data;
                this.$refs['modal'].show();
            },
            DispatchEmails(e) {
                e.preventDefault();
                let form = this.$refs['dispatchform'];
                let formData = new FormData(form);
                formData.append("DispatchDocumentType", this.FileType);
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/ClientAppointments/DispatchEmails", formData, this.DispatchEmailsSuccess, () => { }, true);
            },
            DispatchEmailsSuccess(response) {
                alert(response.data.data);
                this.$refs['modal'].hide();
            },
            SelectAllRecipients(clientSubProgramMembershipID, recipients) {
                //SelectAllRecipients(checklist.ClientSubProgramMembershipID, DispatchRecipients[checklist.ClientSubProgramMembershipID])
                let vm = this;
                recipients.forEach(function (recipient, index) {
                    console.log(vm.$refs['Recipient' + index + '_' + clientSubProgramMembershipID][0]);
                    console.log(vm.$refs['Recipient' + index + '_' + clientSubProgramMembershipID][0].checked);
                    vm.$refs['Recipient' + index + '_' + clientSubProgramMembershipID][0].checked = true;
                });
            }
        },
        components: {
        },
        mounted() {

        },
        computed: {

        }
    }
</script>

<style scoped>
</style>